<template>
  <div class="addAccountingComputerizationNotice">
    <PageHead title="新增预约"></PageHead>

    <div class="detial-cont">
      <div class="detial-cont-title">新增预约配置</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <div class="role-formCont">
          <span class="w100 mr20 rightAlgin">公司/部门:</span>
          <a-tree-select
            v-model="Form.organizationId"
            class="w300"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="treeData"
            placeholder="请选择部门"
            tree-default-expand-all
            :replaceFields="{
              key: 'id',
              value: 'id',
              children: 'treeList',
              title: 'organizationName',
            }"
          >
          </a-tree-select>
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">日期:</span>
          <a-date-picker
            class="w300 ml20"
            valueFormat="YYYY-MM-DD"
            v-model="Form.makeDate"
          />
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">办公阶段:</span>
          <a-radio-group
            class="statistics ml20"
            v-model="Form.officePhase"
            button-style="solid"
          >
            <a-radio-button :value="1"> 全天 </a-radio-button>
            <a-radio-button :value="2"> 上午 </a-radio-button>
            <a-radio-button :value="3"> 下午 </a-radio-button>
          </a-radio-group>
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">是否办公:</span>
          <a-select
            placeholder="是否办公"
            class="w300 ml20"
            v-model="Form.isWork"
          >
            <a-select-option :value="1">是</a-select-option>
            <a-select-option :value="0">否</a-select-option>
          </a-select>
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">办公时间:</span>
          <a-time-picker
            class="ml20"
            v-model="Form.startTime"
            valueFormat="HH:mm"
            format="HH:mm"
          />
          <span class="mr10 ml10"> —— </span>
          <a-time-picker
            v-model="Form.endTime"
            valueFormat="HH:mm"
            format="HH:mm"
          />
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">预约数:</span>
          <a-input-number
            :min="1"
            class="w300 ml20"
            placeholder="请输入预约人数"
            v-model="Form.numbers"
          />
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">预约事由:</span>
          <a-input
            class="w300 ml20"
            placeholder="请输入"
            v-model="Form.makeReservation"
          />
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">办公地点:</span>
          <a-input
            class="w300 ml20"
            placeholder="请输入"
            v-model="Form.officePlace"
          />
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w100 rightAlgin">预约须知:</span>
          <a-textarea
            class="w500 ml20"
            placeholder="请输入预约须知"
            v-model="Form.note"
            :rows="3"
          />
        </div>
        <blank height="20"> </blank>
        <a-button
          style="margin-left: 120px"
          type="primary"
          @click="saveFormFn()"
          :loading="loading"
        >
          确认
        </a-button>
        <a-button style="margin-left: 30px" @click="goback()"> 取消 </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  updateReservationForm,
  ReservationFormDetial,
  addReservationForm,
} from "./api/api";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      Form: {},
      id: "",
    };
  },

  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData, // 组织机构树
    }),
  },
  created() {
    this.getorganizeListFn();
    this.id = this.$route.query.id ? this.$route.query.id : "";
    if (this.id) {
      this.load();
    }
  },

  methods: {
    ...mapActions(["getorganizeListFn"]),
    goback() {
      this.$router.push("/BookingManagement");
    },
    load() {
      ReservationFormDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data;
        }
      });
    },
    saveFormFn() {
      if (!this.Form.organizationId) {
        this.$message.error("请添加部门");
        return false;
      }

      this.loading = true;
      if (this.id) {
        updateReservationForm(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("修改成功");
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
      } else {
        addReservationForm(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("添加成功");
            this.goback();

            this.loading = false;
          } else {
            this.loading = false;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edui-default {
  width: 857px;
  margin: 0 auto;
}
.addAccountingComputerizationNotice {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      // height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.whiteSpace {
  white-space: nowrap;
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
.role-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 120px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BookingManagement/add.vue